// extracted by mini-css-extract-plugin
module.exports = {"supportTypes":"SupportType_supportTypes_2WMPI"};